import { type Context, type Input } from '../types';

// ─────────────────────────────────────────────────────────────────────────────

export function createInitialContext(params: { input: Input }): Context {
  return {
    activeTargetId: params.input.defaultTargetId ?? null,
    programmaticTargetY: null,
    scrollOffset: params.input.scrollOffset,
    scrollViewRef: params.input.scrollViewRef,
    measurements: {},
    targetRefs: {},
    navScrollViewRef: params.input.navScrollViewRef,
    scrollViewDimensions: { contentHeight: 0, viewportHeight: 0 },
  };
}
